import { render, staticRenderFns } from "./CoachVideotag.vue?vue&type=template&id=30f9f474&"
import script from "./CoachVideotag.vue?vue&type=script&lang=js&"
export * from "./CoachVideotag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports